/** @module */
import { AbstractList } from './abstract-list';


/**
 * List of consumer objects.
 * @class
 */
export class List extends AbstractList {}
